import React, {useEffect, useState} from "react";
import './DropDownMenu.style.scss';
import useDeviceType from "../../hooks/useDeviceType";

const arrowSvg = (
    <svg width="37" height="25" viewBox="0 0 37 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <clipPath id="clip-top-half">
                <rect x="0" y="0" width="37" height="12.5" />
            </clipPath>
        </defs>
        <path
            d="M20.4753 1.73035C19.4744 0.440261 17.5256 0.44026 16.5247 1.73035L1.98814 20.4676C0.713797 22.1102 1.88444 24.5 3.96339 24.5H33.0366C35.1156 24.5 36.2862 22.1102 35.0119 20.4676L20.4753 1.73035Z"
            fill="#192832"
            stroke="#35444F"
            clipPath="url(#clip-top-half)"
        />
    </svg>
);


const DropdownMenu = ({ activator, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const {isMobile} = useDeviceType();

    const handleToggle = () => {
        if(!isMobile){
            if (isOpen) {
                handleClose();
            } else {
                setIsOpen(true);
                setIsVisible(true);
            }
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => setIsOpen(false), 300);
    };

    useEffect(() => {
        if (!isOpen) setIsVisible(false);
    }, [isOpen]);

    return (
        <div className={"dropdown-container " + (isOpen ? "open" : "close")}>
            <div onClick={handleToggle}>
                {activator}
            </div>
            {isOpen && (
                <div className={`menu-dropdown ${!isVisible ? 'fade-out' : ''}`}>
                    <div className="menu-arrow">{arrowSvg}</div>
                    <div className="menu-items" onClick={handleClose}>
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;